export default __webpack_public_path__ + "static/436-9ef395eb6ae88273d132b32e5b5f8ecf.gif";